<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <div class="admin-right-sidebar-in-top-left">
                  <h1>
                    {{ constants.MANAGE_UPLOAD_DOCUMENTS_FOR_CHAT_BOT_TEXT }}
                  </h1>
                  <div class="admin-page-type-links">
                    <ul>
                      <li>
                        <a
                          id="allLink"
                          href="#"
                          :class="{ active: activeTab === 'all' }"
                          @click="switchView('all')"
                        >
                          {{ constants.ALL_LINK }}
                          <span>{{ counts.all }}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          id="publishedhLink"
                          href="#"
                          :class="{ active: activeTab === 'published' }"
                          @click="switchView('published')"
                        >
                          {{ constants.PUBLISHED_LINK }}
                          <span>{{ counts.published }}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          id="unPublishedhLink"
                          href="#"
                          :class="{ active: activeTab === 'unpublished' }"
                          @click="switchView('unpublished')"
                        >
                          {{ constants.UNPUBLISHED_LINK }}
                          <span>{{ counts.unpublished }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="admin-right-sidebar-in-top-right">
                  <div class="admin-right-sidebar-in-top-right-top">
                    <div class="">
                      <button
                        id="addBannerBtn"
                        class="admin-btn-primary primary-icon-btn"
                        @click="showAddDocumentForm = true"
                      >
                        <i class="add-icon"></i>
                        {{ constants.ADD_NEW_DOCUMENT_BUTTON }}
                      </button>
                    </div>
                  </div>
                  <div
                    class="admin-right-sidebar-in-top-right-btm"
                    v-if="selectedDocuments.length > 1"
                  >
                    <div class="tags">
                      <ul>
                        <li>
                          <span
                            >{{ selectedDocuments.length }} entries
                            selected</span
                          >
                          <button
                            id="tagCloseBtn"
                            @click="
                              (selectedDocuments = []), (selectAll = false)
                            "
                          ></button>
                        </li>
                      </ul>
                    </div>
                    <div class="delete-all-btn-link">
                      <button
                        class="btn_link"
                        id="deleteAllBtn"
                        data-bs-toggle="modal"
                        data-bs-target="#deletePop"
                        @click="setDeleteMode('all')"
                      >
                        {{ constants.DELETE_ALL_BUTTON }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="white-bg-border add-new-section"
              :class="{ 'show-section': showAddDocumentForm }"
            >
              <div class="add-banner-image-section">
                <h2>
                  {{ constants.ADD_NEW_DOCUMENT_TEXT }}
                </h2>
                <div class="add-banner-image-box">
                  <form id="addBannerImageForm" @submit.prevent="submitForm">
                    <div class="admin-input-field">
                      <label>
                        {{ constants.TITLE_LABEL }}
                      </label>
                      <input
                        id="bnrPgTitleInput"
                        type="text"
                        placeholder="Enter the Title"
                        v-model="newDocument.title"
                      />
                      <div class="error-msg" v-if="!newDocument.title">
                        {{ errors.titleErrMsg }}
                      </div>
                    </div>
                    <!-- <div class="admin-input-field">
                      <label>
                        {{ constants.DESCRIPTION_LABEL }}
                      </label>
                      <div class="text-editer" id="servicesPgDescInput">
                        <img
                          src="../../assets/images/admin-img/demo-img/editer.jpg"
                          alt=""
                          width="100%"
                        />
                      </div>
                    </div> -->
                    <div class="admin-input-field">
                      <label>
                        {{ constants.UPLOAD_DOCUMENT_LABEL }}
                      </label>
                      <div class="image-upload-input upload-banner-image">
                        <div class="image-upload-input-item">
                          <button
                            class="image-upload-input-item-delete-btn"
                            id="uploaded-img-delete-btn"
                            type="button"
                            @click="clearUploadedFile()"
                          ></button>
                          <div class="file-input-box">
                            <input
                              id="bnrPgFileInput"
                              type="file"
                              @change="handleFileUpload($event)"
                            />
                          </div>
                          <div
                            class="image-upload-input-item-in"
                            v-if="!fileUploaded"
                          >
                            <div class="image-upload-input-item-icon">
                              <img
                                src="@/assets/images/admin-img/upload-document-icon.svg"
                                alt=""
                              />
                            </div>
                            <span>
                              {{ constants.ADD_DOCUMENT_LABEL }}
                            </span>
                          </div>
                          <div class="browsed-img" v-if="fileUploaded">
                            {{ fileName }}
                          </div>
                        </div>
                      </div>
                      <div class="error-msg" v-if="!selectedFile">
                        {{ errors.fileErrMsg }}
                      </div>
                    </div>
                    <div class="admin-input-field-submit">
                      <button
                        id="bnrPgSubmitBtn"
                        class="admin-btn-outline-primary"
                        :disabled="isSubmitting"
                      >
                        {{ constants.SUBMIT_BUTTON }}
                      </button>
                      <button
                        id="bnrPgCancelBtn"
                        class="admin-btn-outline-secondary"
                        @click="resetForm"
                      >
                        {{ constants.CANCEL_BUTTON }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="admin-item-list-section upload-documents-section">
              <div class="admin-item-list-section-in">
                <div class="admin-item-list-section-scroll">
                  <div class="admin-item-list-top">
                    <div class="admin-item-list-row">
                      <div class="admin-item-checkbox">
                        <div class="admin-checkbox-input">
                          <input
                            name="cssCheckbox"
                            id="allCheckInput"
                            type="checkbox"
                            class="css-checkbox"
                            @change="toggleSelectAll"
                            :checked="selectAll === true"
                          />
                          <label for="allCheckInput"></label>
                        </div>
                      </div>
                      <div class="admin-item-title">
                        {{ constants.TITLE_LABEL }}
                      </div>
                      <!-- <div class="admin-item-description">
                        {{ constants.DESCRIPTION_LABEL }}
                      </div> -->
                      <div class="admin-item-actions-3">
                        {{ constants.ACTIONS_LABEL }}
                      </div>
                    </div>
                  </div>
                  <div class="admin-item-list-btm">
                    <div
                      v-if="documents.length > 0"
                      class="admin-item-box"
                      v-for="document in documents"
                      :key="document.id"
                    >
                      <div class="admin-item-box-top">
                        <div class="admin-item-list-row">
                          <div class="admin-item-checkbox">
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                :id="'checkItemOneInput' + document.id"
                                type="checkbox"
                                class="css-checkbox"
                                @change="toggleDocumentSelection(document.id)"
                                :checked="
                                  selectedDocuments.includes(document.id)
                                "
                              />
                              <label
                                :for="'checkItemOneInput' + document.id"
                              ></label>
                            </div>
                          </div>
                          <div class="admin-item-title text-limit">
                            {{ document.title }}
                          </div>
                          <!-- <div class="admin-item-description text-limit">
                            Document Description Here
                          </div> -->
                          <div class="admin-item-actions-3">
                            <ul class="admin-action-link">
                              <li>
                                <button
                                  id="bnrPgDeleteBtn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deletePop"
                                  @click="
                                    setDeleteMode('single', document.id),
                                      (showAddDocumentForm = false)
                                  "
                                >
                                  {{ constants.DELETE_BUTTON }}
                                </button>
                              </li>
                              <li>
                                <button
                                  id="bnrPgPublishBtn"
                                  v-if="document.status === 1"
                                  @click="changeDocumentStatus(document.id, 0)"
                                >
                                  {{ constants.UNPUBLISH_BUTTON }}
                                </button>
                                <button
                                  id="bnrPgPublishBtn"
                                  v-else-if="document.status === 0"
                                  @click="changeDocumentStatus(document.id, 1)"
                                >
                                  {{ constants.PUBLISH_BUTTON }}
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p>No data to display</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-pagination-section">
                <div class="custom-row">
                  <div class="item-show-selectbox">
                    <select
                      id="paginationSelectBox"
                      v-model="limit"
                      @change="handleLimitChange"
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <span>
                      {{ constants.ENTRIES_PER_PAGE_LABEL }}
                    </span>
                  </div>
                  <div
                    class="admin-pagination"
                    id="paginationBox"
                    v-if="totalPages > 1"
                  >
                    <ul>
                      <li
                        v-if="currentPage !== 1"
                        @click="changePage(currentPage - 1)"
                      >
                        <a href="#" class="pagination-previous"></a>
                      </li>
                      <li
                        v-for="page in visiblePages"
                        :key="page"
                        @click="changePage(page)"
                        v-if="totalPages != 1"
                      >
                        <a href="#" :class="{ active: currentPage === page }">{{
                          page
                        }}</a>
                      </li>
                      <li
                        v-if="currentPage !== totalPages"
                        @click="changePage(currentPage + 1)"
                      >
                        <a href="#" class="pagination-next"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
    <div
      class="modal fade confirmation-popup"
      id="deletePop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i>
              <img
                src="@/assets/images/admin-img/light_delete-outline.svg"
                alt=""
              />
            </i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmDelete"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { API_BASE_URL } from "@/config/api.config";
import axios from "axios";
import Swal from "sweetalert2";
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface Document {
  id: number;
  title: string;
  file: string;
  status: number;
}

export default defineComponent({
  name: "UploadDocument",
  data() {
    return {
      constants,
      activeTab: "all",
      counts: {
        all: 0,
        published: 0,
        unpublished: 0,
      } as any,
      documents: [] as Document[],
      limit: 10,
      totalPages: 0,
      currentPage: 1,
      newDocument: {
        title: "",
        file: "",
        status: 0,
      } as Omit<Document, "id">,
      documentToDelete: null as number | null,
      deleteMode: "all" as "all" | "single",
      isSubmitting: false,
      sortBy: "-created_at" as string,
      fileName: "",
      selectedFile: null as File | null,
      fileUploaded: false,
      selectedDocuments: [] as number[],
      selectAll: false,
      errors: {
        titleErrMsg: "",
        fileErrMsg: "",
      },
      showAddDocumentForm: false,
    };
  },
  components: {
    adminHeader,
    adminNavigation,
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      next({ name: "Login" });
    } else {
      next();
    }
  },
  computed: {
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;
      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  created() {
    this.limit = getPaginationLimit("documents", 10);
    this.fetchCounts();
    this.fetchDocuments();
  },
  methods: {
    async fetchDocuments(
      status = "all",
      limit?: number,
      skip = 0,
      //@ts-expect-error
      sortBy = this.sortBy
    ) {
      const effectiveLimit = limit ?? this.limit;
      let url = `${API_BASE_URL}/documents/`;
      const params = new URLSearchParams();
      if (status === "published") params.append("status", "1");
      else if (status === "unpublished") params.append("status", "0");
      params.append("limit", effectiveLimit.toString());
      params.append("skip", skip.toString());
      params.append("sort_by", sortBy);
      try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.documents = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit);
      } catch (error: any) {
        console.error("Error fetching documents:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to Fetch Documents",
          text: error.response?.data?.detail || "Please try again.",
          showConfirmButton: true,
        });
      }
    },
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/documents/count/`;
        const [allResponse, publishedResponse, unpublishedResponse] =
          await Promise.all([
            axios.get(`${baseUrl}?status=0&status=1`),
            axios.get(`${baseUrl}?status=1`),
            axios.get(`${baseUrl}?status=0`),
          ]);
        this.counts = {
          all: allResponse.data.count,
          published: publishedResponse.data.count,
          unpublished: unpublishedResponse.data.count,
        };
        if (this.activeTab in this.counts) {
          this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
        } else {
          console.error(`Invalid active tab: ${this.activeTab}`);
        }
      } catch (error: any) {
        console.error("Error fetching document counts:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to Fetch Counts",
          text: error.response?.data?.detail || "Please try again.",
          showConfirmButton: true,
        });
      }
    },
    async submitForm() {
      this.errors = {
        titleErrMsg: "",
        fileErrMsg: "",
      };
      if (!this.newDocument.title) {
        this.errors.titleErrMsg = "Title is required";
      }
      if (!this.selectedFile) {
        this.errors.fileErrMsg = "File is required";
      }
      if (this.errors.titleErrMsg || this.errors.fileErrMsg) {
        return;
      }

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append("title", this.newDocument.title);
      formData.append("file", this.selectedFile!);
      try {
        await axios.post(`${API_BASE_URL}/documents/`, formData);
        await this.fetchCounts();
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
          this.currentPage = Math.ceil(
            this.counts[this.activeTab] / this.limit
          );
        }
        await this.fetchDocuments(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        this.fileUploaded = false;
        this.resetForm();
        Swal.fire({
          icon: "success",
          title: "Document Created Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.error("Error submitting document:", error);
      } finally {
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.newDocument = {
        title: "",
        file: "",
        status: 0,
      };
      this.selectedFile = null;
      this.fileName = "";
      this.fileUploaded = false;
      this.showAddDocumentForm = false;
      this.errors = {
        titleErrMsg: "",
        fileErrMsg: "",
      };
    },
    async switchView(status: string) {
      this.currentPage = 1;
      this.activeTab = status;
      this.selectedDocuments = [];
      this.selectAll = false;
      this.showAddDocumentForm = false;
      await this.fetchDocuments(status, this.limit, 0);
      if (status === "published") {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
      } else if (status === "unpublished") {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
      } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
      }
    },
    handleFileUpload(event: any, isEdit: boolean = false) {
      const target = event.target as HTMLInputElement;
      if (target && target.files && target.files.length > 0) {
        const file = target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          if (e.target && typeof e.target.result === "string") {
            this.selectedFile = file;
            this.fileName = this.selectedFile.name;
            this.fileUploaded = true;
          }
        };
      }
    },
    clearUploadedFile() {
      this.fileName = "";
      this.selectedFile = null;
      this.fileUploaded = false;
      const fileInput = document.getElementById(
        "bnrPgFileInput"
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = "";
      }
    },
    handleLimitChange() {
      setPaginationLimit("documents", this.limit);
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
      this.selectAll = false;
      this.selectedDocuments = [];
      this.fetchDocuments(this.activeTab, this.limit, 0);
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchDocuments(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        this.selectAll = false;
        this.selectedDocuments = [];
      }
    },
    setDeleteMode(mode: "all" | "single", documentId?: number) {
      this.deleteMode = mode;
      if (documentId !== undefined) {
        this.documentToDelete = documentId;
      }
    },
    async confirmDelete() {
      if (this.deleteMode === "all") {
        await this.deleteSelectedDocuments();
      } else if (this.deleteMode === "single") {
        await this.deleteDocument();
      }
    },
    async deleteSelectedDocuments() {
      try {
        await axios.delete(`${API_BASE_URL}/documents/bulk_delete/`, {
          data: { ids: this.selectedDocuments },
        });
        this.documents = this.documents.filter(
          (document) => !this.selectedDocuments.includes(document.id)
        );
        this.selectedDocuments = [];
        await this.fetchCounts();
        await this.fetchDocuments(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        if (this.documents.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchDocuments(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          );
        }
        this.selectAll = false;
      } catch (error) {
        console.error("Error deleting documents:", error);
      }
    },
    async deleteDocument() {
      try {
        await axios.delete(
          `${API_BASE_URL}/documents/${this.documentToDelete}/`
        );
        await this.fetchCounts();
        await this.fetchDocuments(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        if (this.documents.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchDocuments(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          );
        }
      } catch (error) {
        console.error("Error deleting document:", error);
      }
    },
    toggleSelectAll() {
      if (this.selectAll === true) {
        this.selectedDocuments = [];
        this.selectAll = false;
      } else {
        this.selectedDocuments = this.documents.map((document) => document.id);
        this.selectAll = true;
      }
    },
    toggleDocumentSelection(documentId: number) {
      if (this.selectedDocuments.includes(documentId)) {
        this.selectedDocuments = this.selectedDocuments.filter(
          (id) => id !== documentId
        );
      } else {
        this.selectedDocuments.push(documentId);
      }
    },
    async changeDocumentStatus(documentId: number, newStatus: number) {
      try {
        const formData = new FormData();
        formData.append("status", newStatus.toString());
        const response = await axios.patch(
          `${API_BASE_URL}/documents/${documentId}/`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        await this.fetchCounts();
        await this.fetchDocuments(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        if (this.documents.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchDocuments(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          );
        }
      } catch (error: any) {
        console.error("Error updating document status:", error);
      }
    },
  },
});
</script>
